import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { SearchStateType } from "../../../Orchestrator/Types/Index";
import { IPopulateSearchForCmsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/IPopulateSearchForCmsActionParams";
import { ICmsRoute } from "../../../Orchestrator/Types/Interface/ICmsRoutes";

export class PopulateSearchForCmsAction extends BaseAction<void, IPopulateSearchForCmsActionParams> {
  override async run(): Promise<void> {
    try {

      let newSearchData: Partial<SearchStateType> = {};

      const { search, origin, destination } = this.params!;

      newSearchData = {
        ...search,
        from: origin.code || "",
        fromName: origin.name || "",
        to: destination.code || "",
        toName: destination.name || "",
        fromShuttle: false,
        toShuttle: false,
        fromfmlmSearch: false,
        tofmlmSearch: false,
        fromGeoPosition: null,
        toGeoPosition: null,
      }

      updateRecoilState("searchStateAtom", newSearchData);
      updateRecoilState("isSelectingOriginAtom", false);
      updateRecoilState("isSelectingDestinationAtom", false);

      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (error) {
      console.error("Error in PopulateSearchForCmsAction:", error);
    }
  }
}

export const populateSearchForCmsAction = new PopulateSearchForCmsAction();
